import { useTranslation } from 'react-i18next';
import { Magnet } from 'lucide-react';
import FormCard from './FormCard';
import TechnicalSpecsSection from './TechnicalSpecsSection';
import SpatialGradientSection from './SpatialGradientSection';
import MaxSARSection from './MaxSARSection';

export default function ScannerCard() {
    const { t } = useTranslation();

    return (
        <FormCard
            icon={Magnet}
            title={t('roomOverview.mriMachineForm.sections.scanner')}
            description={t(
                'roomOverview.mriMachineForm.sections.scannerDescription'
            )}
        >
            <div className="divide-y divide-subtle [&>*:first-child]:pt-0 [&>*:last-child]:pb-0 [&>*]:py-6">
                <TechnicalSpecsSection />
                <SpatialGradientSection />
                <MaxSARSection />
            </div>
        </FormCard>
    );
}
